import { combineReducers } from 'redux';

import player from './player/state/reducer';
import videoSource from './player/videoSource/reducer';

export default combineReducers({
    player,
    videoSource
});



// WEBPACK FOOTER //
// ./src/reducers.js